import React from 'react';

import type { MarkdownTextBlock, RedirectRule, AnswerState } from '../types';
import { useChatSearch } from '../ChatSearchContext';

import { FormattedMessage } from '@/components/markdown/FormattedMessage';

export interface MarkdownTextBlockProps {
  block: MarkdownTextBlock;
  redirectRules?: RedirectRule[];
  state: AnswerState;
}

export function MarkdownTextBlock({ block, redirectRules, state }: MarkdownTextBlockProps) {
  const { contentTypeEndpoint } = useChatSearch();

  if (!block.text || block.text.trim() === '') {
    return (
      <div className="w-full py-4">
        <div className="space-y-4">
          <div className="space-y-3">
            <div className="h-4 rounded w-3/4 shimmer" />
            <div className="h-4 rounded w-full shimmer" />
            <div className="h-4 rounded w-5/6 shimmer" />
          </div>
        </div>
      </div>
    );
  }

  const { text } = block;

  return (
    <div className="w-full">
      <div className="prose prose-sm max-w-none text-foreground">
        <FormattedMessage
          message={{
            content: text,
          }}
          redirectRules={redirectRules}
          isStreaming={state === 'streaming'}
          contentTypeEndpoint={contentTypeEndpoint}
        />
      </div>
    </div>
  );
}
